import lazyLoad from '../../lazyload/lazyLoad.js';

const dummyEqual = function () {
    return false;
};

export default class AppNexus {
    constructor (params) {
        this.apntag = params.apntag || {};
        this.apntag.anq = this.apntag.anq || [];
        this.server = params.server;
        this._window = params._window;
        this.member = params.member;
        this.isEqual = params.isEqual || dummyEqual;
        this.loaded = {};
    }

    clearWallpaper () {
        let body;
        if (window === window.top) {
            body = document.body;
        } else {
            body = window.parent.document.body;
        }
        body.style.cssText = '';
    }

    collapseTopboard () {
        const topboard = document.querySelector('#topboard');
        if (topboard) {
            topboard.style.height = null;
        }
    }

    clearSkyscraperleft () {
        const skyscraper = document.querySelector('#skyscraperleft_1');
        if (skyscraper) {
            skyscraper.innerHTML = '';
        }
    }

    showBoards (elements) {
        if (elements) {
            lazyLoad(elements, this._showOrRefreshBoards.bind(this));
        }
    }

    showBanners (elements = [], data = {}) {
        if (elements) {
            const horseShoe = [];
            let wallpaper;
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].getAttribute('data-astbanner-name') === 'wallpaper') {
                    wallpaper = elements[i];
                } else {
                    horseShoe.push(elements[i]);
                }
            }
            if (this.isEqual(this.data, data) && this.config) {
                lazyLoad(horseShoe, this._refreshBanners.bind(this));
                if (wallpaper) {
                    this._refreshBanners(wallpaper);
                }
            } else {
                if (this.apntag.clearRequest) {
                    this.apntag.clearRequest();
                }
                this._getConfig(data, this._loadBanners.bind(this));
                lazyLoad(horseShoe, this._showBanners.bind(this));
                if (wallpaper) {
                    this._showBanners(wallpaper);
                }
            }
        }
    }

    data () {
        return this.data;
    }

    _loadBanners (config) {
        const appNexusConfig = JSON.parse(JSON.stringify(config));
        if (Object.keys(appNexusConfig).length > 0) {
            this.apntag.anq.push(() => {
                if (this.member) {
                    appNexusConfig.pageOpts.member = this.member;
                }
                this.apntag.setPageOpts(appNexusConfig.pageOpts);
                for (const tag in appNexusConfig.tags) {
                    if (appNexusConfig.tags.hasOwnProperty(tag)) {
                        this.apntag.defineTag(appNexusConfig.tags[tag]);

                        if (tag === 'wallpaper') {
                            this.apntag.onEvent('adNoBid', 'wallpaper', this.clearWallpaper);
                        }
                        if (tag === 'topboard') {
                            this.apntag.onEvent('adNoBid', 'topboard', this.collapseTopboard);
                        }
                        if (tag === 'skyscraperleft_1') {
                            this.apntag.onEvent('adNoBid', 'skyscraperleft_1', this.clearSkyscraperleft);
                        }
                        this._handleNativeFormat(tag);
                    }
                }
                this.apntag.loadTags();
            });
        }
    }

    _handleNativeFormat (tag) {
        this.apntag.onEvent('adAvailable', tag, (adObj) => {
            const element = document.querySelector(`#${tag}`);
            if (adObj.adType === 'native' && element) {
                element.innerHTML =
                    '<div class="native-add native-add-markasadd">' +
                    '<div class="native-add__wrap">' +
                    `<a href="${adObj.native.clickTrackers[0]}./clickenc=${adObj.native.clickUrl}" ` +
                    'class="native-add__media linkblock dark-links clickable" target="_blank">' +
                    `<img class="native-add__media__img" src="${adObj.native.mainMedia[0].url}" alt="Annonsebilde" />` +
                    '<div class="native-add__media__caption">' +
                    `<div class="native-add__sponsoredBy">annonse fra ${adObj.native.sponsoredBy}</div>` +
                    `<div class="native-add__title">${adObj.native.title}</div>` +
                    '<div class="native-add__media__logo">' +
                    `<img class="native-add__media__img" src="${adObj.native.iconImgUrl}" alt="${adObj.native.sponsoredBy}" />` +
                    `<img src="${adObj.native.impressionTrackers[0]}" height="0" width="0" style="display: none;" alt="" />` +
                    '</div>' +
                    '</div>' +
                    '</a>' +
                    '</div>' +
                    '</div>';
            }
        });
    }

    _refreshBanners (element) {
        const tagIds = [];
        tagIds.push(element.id);
        this.apntag.anq.push(() => {
            this.apntag.refresh(tagIds);
        });
    }

    _showBanners (element) {
        const tagId = element.id;
        this.apntag.anq.push(() => {
            this.apntag.showTag(tagId);
        });
    }

    _showOrRefreshBoards (element) {
        const tagId = element.id;
        if (this.loaded[tagId] && this.loaded[tagId].config === this.config) {
            this.apntag.anq.push(() => {
                this.apntag.refresh(tagId);
            });
        } else {
            this.loaded[tagId] = { config: this.config };
            this.apntag.anq.push(() => {
                this.apntag.showTag(tagId);
            });
        }
    }

    _getConfig (data, callback) {
        this.data = data;
        this.server.loadJsonCors(
            `/${this._window.FINN.travel.banner.vertical}/${this._window.FINN.travel.banner.appNexusPage}/${this._window.FINN.travel.banner.device || this._window.FINN.travel.device}`, data, (error, appNexusConfig) => { // eslint-disable-line max-len
                if (!error) {
                    this.config = appNexusConfig;
                    callback(appNexusConfig);
                }
            });
    }
}



// WEBPACK FOOTER //
// /mnt/build-dir/TRAVELAPP-FRONTPAGEDEPLOY-FRONTPAGEPIPELINE/shared/overlay/src/main/webapp/scripts/banners/appNexus/appNexus.js